export class Url {
    constructor({
                    //attributes
                    id= null,
                    campaign_id = null,
                    name= '',
                    urlkey= '',
                    created_at= new Date(),
                    updated_at= new Date()
                    //relations
                } = {}) {

        //fill attributes

        this.id= id;
        this.campaign_id=campaign_id;
        this.name=name;
        this.urlkey=urlkey;
        this.created_at=created_at;
        this.updated_at=updated_at;


    }

}

export function createUrl(data={}) {
    return Object.freeze(new Url(data));
}